import axios from "axios";
import authHeader from "./auth-header";
import setupInterceptors from "./setupInterceptors";

export default () => {
  let apiUrl = "https://www.delphinpiraye.com/api"; // Default fallback

  if (typeof window !== "undefined") {
    const href = window.location.href;
    if (
      href.startsWith("https://test.delphinpiraye.com") ||
      href.startsWith("http://localhost:4200")
    ) {
      apiUrl = "https://test.delphinpiraye.com/api";
    } else if (
      href.startsWith("https://www.delphinpiraye.com") ||
      href.startsWith("https://delphinpiraye.com")
    ) {
      apiUrl = "https://www.delphinpiraye.com/api";
    }
  }
  //console.log("Current apiUrl:", apiUrl);
  // const instance = axios.create({
  //   baseURL: prod
  //     ? "https://www.delphinpiraye.com/api"
  //     : "http://localhost:5000/api", //      : "http://localhost:60805/api",
  //   //"https://delphinpiraye.net/api"
  //   //: "https://delphinpiraye.net/api",
  //   headers: authHeader(),
  // });

  const instance = axios.create({
    baseURL: apiUrl,
    headers: authHeader(),
  });
  setupInterceptors(instance);
  return instance;
};
